// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { ChallengeReviewsStatisticsData, ChallengeReviewsListData } from '../../types/ChallengeReviewsData';

export interface ChallengeReviewsRequestPayload {
  id: string;
  loadingType: LoadingType;
  condition: string;
}
export interface ChallengeReviewsSuccessPayload {
  ChallengeReviewsStatistics: ChallengeReviewsStatisticsData;
  ChallengeReviewsList: ChallengeReviewsListData[];
  id: string;
  loadingType: LoadingType;
}

export interface ChallengeReviewsFailPayload {
  error: Error;
}

export const getChallengeReviewsActions = createAsyncAction(
  'elearning/GET_CHALLENGE_REVIEWS',
  'elearning/GET_CHALLENGE_REVIEWS_SUCCESS',
  'elearning/GET_CHALLENGE_REVIEWS_FAIL'
)<
  ChallengeReviewsRequestPayload,
  ChallengeReviewsSuccessPayload,
  ChallengeReviewsFailPayload
>();
